"use client";

import {
  IconBrandFacebook,
  IconBrandLinkedin,
  IconBrandX,
  IconMenu2,
  IconX,
} from "@tabler/icons-react";
import Link from "next/link";
import { useEffect, useState } from "react";
import { useScrollLock } from "../hooks/useScrollLock";
import { Search } from "./search";
import { usePathname } from "next/navigation";

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const pathname = usePathname();
  useScrollLock(isMenuOpen);

  // Close menu on navigation
  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  return (
    <header
      className="xl:max-w-[1380px] mx-auto border-b border-t border-black text-black
        h-[50px] lg:h-[62px] xl:h-[70px]
        mt-4 mb-[40px] xs:mb-[52px] md:mb-[60px] w-full"
    >
      <div className="grid gap-[20px] grid-cols-1 lg:grid-cols-3 justify-between items-center h-full max-w-[1380px] mx-auto">
        <div className="hidden lg:flex pl-3 flex-1 justify-between max-w-[300px] gap-2 justify-self-start">
          <Link href="/categories">Categories</Link>
          <div>|</div>
          <Link href="/guests">Guests</Link>
          <div>|</div>
          <Search />
        </div>
        <div className="w-full lg:text-center">
          <div className="flex justify-between items-center px-[10px] xs:px-[60px] md:px-[75px] lg:px-[0px]">
            <Link
              href="/"
              className="font-heading font-bold text-lg xs:text-2xl md:text-[28px] xl:text-[32px] text-nowrap"
            >
              Indian Religions Podcast
            </Link>
            <div className="flex lg:hidden relative">
              <div className="menu-button">
                {isMenuOpen ? (
                  <IconX
                    className="cursor-pointer"
                    onClick={() => setIsMenuOpen(false)}
                  />
                ) : (
                  <IconMenu2
                    className="cursor-pointer"
                    onClick={() => setIsMenuOpen(true)}
                  />
                )}
              </div>

              {isMenuOpen && (
                <ul
                  className="mobile-menu-container fixed top-[66px] left-0 w-full text-center z-50"
                  style={{ backgroundColor: "#fafafa" }}
                >
                  <li>
                    <Link
                      className="block p-4 border-b border-black"
                      href="/categories"
                    >
                      Categories
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="block p-4 border-b border-black"
                      href="/guests"
                    >
                      Guests
                    </Link>
                  </li>
                  <li>
                    <div className="block p-4 border-b border-black">
                      <Search />
                    </div>
                  </li>
                  <li>
                    <Link
                      className="block p-4 border-b border-black"
                      href="/contact"
                    >
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="block p-4 border-b border-black"
                      href="/about"
                    >
                      About
                    </Link>
                  </li>
                  <li className="p-4 border-b border-black flex items-center justify-center gap-4">
                    <a
                      href="https://www.facebook.com/drrajbalkaran"
                      aria-label="Facebook"
                      target="_blank"
                    >
                      <IconBrandFacebook width={24} height={24} />
                    </a>
                    <a
                      href="https://x.com/DrRajBalkaran"
                      aria-label="Twitter"
                      target="_blank"
                    >
                      <IconBrandX width={24} height={24} />
                    </a>
                    <a
                      href="https://www.linkedin.com/in/drrajbalkaran/"
                      aria-label="LinkedIn"
                      target="_blank"
                    >
                      <IconBrandLinkedin width={24} height={24} />
                    </a>
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
        <div className="hidden lg:flex pr-3 between flex-1 justify-between max-w-[300px] gap-2 justify-self-end">
          <Link href="/contact">Contact</Link>
          <div>|</div>
          <Link href="/about">About</Link>
          <div>|</div>
          <div className="flex gap-4">
            <a
              href="https://www.facebook.com/drrajbalkaran"
              aria-label="Facebook"
              target="_blank"
            >
              <IconBrandFacebook width={24} height={24} />
            </a>
            <a
              href="https://x.com/DrRajBalkaran"
              aria-label="Twitter"
              target="_blank"
            >
              <IconBrandX width={24} height={24} />
            </a>
            <a
              href="https://www.linkedin.com/in/drrajbalkaran/"
              aria-label="LinkedIn"
              target="_blank"
            >
              <IconBrandLinkedin width={24} height={24} />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
